export enum AddressFields {
  AddressLine1 = 'addressLine1',
  AddressLine2 = 'addressLine2',
  ZipCode = 'zipCode',
  City = 'city',
  StateRegion = 'stateRegion',
  Country = 'country',
}
